import { render, staticRenderFns } from "./AddFooter.vue?vue&type=template&id=73164022&scoped=true&"
import script from "./AddFooter.vue?vue&type=script&lang=js&"
export * from "./AddFooter.vue?vue&type=script&lang=js&"
import style0 from "./AddFooter.vue?vue&type=style&index=0&id=73164022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73164022",
  null
  
)

export default component.exports